import { useState } from "react";
import { Input, Button } from "@heroui/react";
import SendIcon from "@mui/icons-material/Send";

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export function ChatInput({ onSend, disabled }: ChatInputProps) {
  const [value, setValue] = useState("");

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend(value);
      setValue("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="flex items-center gap-2 p-4 border-t border-gray-200 bg-white">
      <Input
        value={value}
        onValueChange={setValue}
        onKeyDown={handleKeyDown}
        placeholder="Type a message..."
        disabled={disabled}
        classNames={{
          input: "text-sm",
          inputWrapper: "bg-gray-50",
        }}
      />
      <Button
        isIconOnly
        className="bg-[#215273] text-white"
        onPress={handleSend}
        isDisabled={disabled || !value.trim()}
      >
        <SendIcon fontSize="small" />
      </Button>
    </div>
  );
}
